import { React, useState, useEffect, Toast, Icon, useUser } from "../utils/commonImports";
import { Container, Spinner } from "reactstrap";
import { _api } from "../auth/Api";
import RichTextEditor from '../components/RichTextEditor'
import { getPageRights } from "../utils/accessPages";

export const AppSettingEditor = ({ title, settingCode, pageId }) => {
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [richText, setRichText] = useState("");
  const [appSetting, setAppSetting] = useState(null);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || []; 
  const rights = getPageRights(userPages, pageId);  

  useEffect(() => {
    _getContent();
  }, []);

  const _getContent = async () => {
    try {
      await _api("GET", `AppSetting/GetAppSettings?code=${settingCode}`, null, (res) => {
        if (res.isSuccess) {
          setAppSetting(res.data);
          setHtmlContent(res.data.value || "");
        }
      });
    } catch (err) {
      console.error("Failed to load data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setRichText(htmlContent);
    setEditMode(true);
  };

  const handleSave = async () => {
    if (!appSetting) return;
    const payload = {
      id: appSetting.id,
      code: appSetting.code,
      title: appSetting.title,
      isBoolean: appSetting.isBoolean,
      isEnabled: appSetting.isEnabled,
      value: richText
    };
    try {
      await _api("POST", "AppSetting/UpdateAppSetting", payload, (res) => {
        if (res?.isSuccess) {
          Toast.fire({ icon: "success", title: res.message });
          setHtmlContent(richText);
          setEditMode(false);
          _getContent();
        } else {
          Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner color="primary" />
      </Container>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center border p-3 rounded bg-light mb-3">
        <span className="fw-semibold mb-0 text-sm" style={{ color: "#124880" }}>{title} Content</span>
        {rights && rights.edit &&(
        <Icon icon="feather:edit" className="me-1" style={{ cursor: "pointer", color: "#124880" }} onClick={handleEdit} />)}
      </div>
      {!editMode ? (
        <div className="border p-3 rounded bg-light mb-3">
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
      ) : (
        <>
          <RichTextEditor value={richText} onChange={setRichText} />
          <div className="mt-3 gap-2 d-flex justify-content-end">
            <button onClick={handleSave} className="btn btn-outline-primary-600 px-14 py-6 text-sm radius-3" style={{ lineHeight: '1.2' }}>
              Save Changes
            </button>
            <button onClick={() => setEditMode(false)} className="btn btn btn-outline-dark px-14 py-6 text-sm radius-3" style={{ lineHeight: '1.2' }}>
              Cancel
            </button>
          </div>
          {/* <div className="mt-3">
            <Button color="success" onClick={handleSave}>Save</Button>{" "}
            <Button color="secondary" onClick={() => setEditMode(false)}>Cancel</Button>
          </div> */}
        </>
      )}
    </>
  );
};